module.exports = __webpack_public_path__ + "img/oil-gas-finder-header.a87d8e88.jpg";